module.exports = __webpack_public_path__ + "img/shortstay-small-image-1.8b107b31.png";